/** Lazy screen loaders. Each screen is `screens/<name>/index.tsx` with a default export. */
export const screenLoaders = {
  today: () => import("../screens/today"),
  people: () => import("../screens/people"),
  events: () => import("../screens/events"),
  email: () => import("../screens/email"),
  money: () => import("../screens/money"),
  settings: () => import("../screens/settings"),
  labs: () => import("../screens/labs"),
};

/** Fetch every screen's code once the first screen is up, so switching jobs never waits. */
export function preloadScreens(): void {
  for (const load of Object.values(screenLoaders)) void load();
}
